import { LIMITES_UPLOAD } from '@fiscoai/contracts';

export type TipoEnvio = 'ARQUIVOS' | 'PLANILHA';

export interface Envio {
  tipo: TipoEnvio;
  arquivos: File[];
  empresaId?: string | undefined;
}

export const EXTENSOES_DOCUMENTO = ['.xml', '.zip'] as const;
export const EXTENSOES_PLANILHA = ['.csv', '.xlsx'] as const;
export const EXTENSOES = [...EXTENSOES_DOCUMENTO, ...EXTENSOES_PLANILHA] as const;

function extensao(nome: string): string {
  return nome.slice(nome.lastIndexOf('.')).toLowerCase();
}

export function ehPlanilha(arquivo: File): boolean {
  return (EXTENSOES_PLANILHA as readonly string[]).includes(extensao(arquivo.name));
}

export type Deteccao =
  { ok: true; tipo: TipoEnvio; arquivos: File[] } | { ok: false; motivo: string };

/** Decide o tipo do envio pelos arquivos escolhidos e confere os limites antes de subir. */
export function detectar(arquivos: readonly File[]): Deteccao {
  if (arquivos.length === 0) return { ok: false, motivo: 'Escolha ao menos um arquivo.' };
  const planilha = arquivos.find(ehPlanilha);
  if (planilha) {
    if (arquivos.length > 1) {
      return { ok: false, motivo: 'Envie a planilha sozinha. XMLs e ZIPs vão num envio separado.' };
    }
    if (planilha.size > LIMITES_UPLOAD.bytesPorPlanilha)
      return { ok: false, motivo: 'A planilha passa de 20 MB.' };
    return { ok: true, tipo: 'PLANILHA', arquivos: [planilha] };
  }
  if (arquivos.length > LIMITES_UPLOAD.arquivosPorEnvio) {
    return {
      ok: false,
      motivo: `No máximo ${String(LIMITES_UPLOAD.arquivosPorEnvio)} arquivos por envio. Junte-os num ZIP.`,
    };
  }
  const grande = arquivos.find((a) =>
    extensao(a.name) === '.zip'
      ? a.size > LIMITES_UPLOAD.bytesPorZip
      : a.size > LIMITES_UPLOAD.bytesPorXml,
  );
  if (grande) return { ok: false, motivo: `${grande.name} passa do tamanho permitido.` };
  return { ok: true, tipo: 'ARQUIVOS', arquivos: [...arquivos] };
}
